import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('messages');
export const findByIdThrows = createFindByIdThrows('messages');
